// @ts-ignore Interframe is not yet migrated
import Interframe from 'interframe';
import { MessageTypes as InterframeMessageTypes } from 'interframe/Constants';
import { Environment } from 'signup-ui-lego-core/constants/Environment';
import { ACKNOWLEDGE_MESSAGE_TYPE, CONNECTION_ESTABLISHED_MESSAGE_TYPE, HANDSHAKE_MESSAGE_TYPE, INTEGRATION_MODAL_ACTION_MESSAGE_TYPE, INTEGRATION_MODAL_CONFIG_MESSAGE_TYPE, INTEGRATION_MODAL_STEP_MESSAGE_TYPE, SIGNUP_STARTED_MESSAGE_TYPE } from './constants/MessageTypes';
export class SignupIntegrationModalEmbedder {
  constructor() {
    this.config = null;
    this.environment = Environment.prod;
    this.actionCallback = null;
    this.handshaked = false;
    this.wrapperElement = null;
    this.handleInterframeMessage = message => {
      const {
        type
      } = message;
      if (type === SIGNUP_STARTED_MESSAGE_TYPE) {
        this.handleAppStarted();
      } else if (type === INTEGRATION_MODAL_ACTION_MESSAGE_TYPE) {
        if (this.actionCallback && message.action) {
          this.actionCallback(message.action, message.data);
        }
      }
    };
  }
  setConfig(config) {
    this.config = config;
    return this;
  }
  setEnvironment(environment) {
    if (!Object.values(Environment).includes(environment)) {
      throw new Error(`Invalid environment: ${environment}`);
    }
    this.environment = typeof environment === 'string' ? Environment[environment] : environment;
    return this;
  }
  onAction(callback) {
    this.actionCallback = callback;
    return this;
  }
  setStep(step) {
    if (!this.interframe) {
      throw new Error('Cannot set step before attaching to an element.');
    }
    this.interframe.postMessage({
      type: INTEGRATION_MODAL_STEP_MESSAGE_TYPE,
      step
    }, InterframeMessageTypes.JSON);
  }
  completeConnection(success) {
    if (!this.interframe) {
      throw new Error('Cannot complete connection before attaching to an element.');
    }
    this.interframe.postMessage({
      type: CONNECTION_ESTABLISHED_MESSAGE_TYPE,
      success
    }, InterframeMessageTypes.JSON);
  }
  destroy() {
    if (this.wrapperElement && this.wrapperElement.parentNode) {
      this.wrapperElement.parentNode.removeChild(this.wrapperElement);
      this.wrapperElement = null;
    }
    this.actionCallback = null;
    this.handshaked = false;
  }
  attachTo(element) {
    if (!element) {
      throw new Error('You must provide a valid HTML element.');
    }
    let attachableElement;
    if (!(element instanceof HTMLElement) && typeof element === 'string') {
      const queryElement = document.querySelector(element);
      if (!queryElement) {
        throw new Error(`Could not find element: ${element}`);
      }
      attachableElement = queryElement;
    } else {
      attachableElement = element;
    }
    const iframe = this.buildIframe();
    this.wrapperElement = this.prepareElement(attachableElement);
    this.wrapperElement.appendChild(iframe);
    if (iframe.contentWindow) {
      this.setupInterframe(iframe.contentWindow);
    }
    return this;
  }
  getSignupDomain() {
    const isLocalOrQa = [Environment.local, Environment.qa].includes(this.environment);
    const subdomain = this.environment === Environment.local ? 'local' : 'app';
    const extension = isLocalOrQa ? 'qa' : '';
    return `https://${subdomain}.hubspot${extension}.com`;
  }
  getIframeUrl() {
    const domain = this.getSignupDomain();
    const embeddingPage = encodeURIComponent(`${window.location.origin}${window.location.pathname}`);
    return `${domain}/signup-hubspot/integration-modal?_seia=1&_sebp=${embeddingPage}`;
  }
  buildIframe() {
    const iframe = document.createElement('iframe');
    iframe.id = 'signup-integration-modal-embedded';
    iframe.title = 'HubSpot Integration Signup';
    iframe.style.position = 'absolute';
    iframe.style.width = '100%';
    iframe.style.height = '100%';
    iframe.style.border = 'none';
    iframe.referrerPolicy = 'origin';
    iframe.allow = 'keyboard-map *';
    iframe.src = this.getIframeUrl();
    return iframe;
  }
  prepareElement(element) {
    const wrapper = document.createElement('div');
    wrapper.style.position = 'relative';
    wrapper.style.width = '100%';
    wrapper.style.height = '100%';
    wrapper.style.minHeight = '600px';
    element.appendChild(wrapper);
    return wrapper;
  }
  setupInterframe(windowInstance) {
    const referrer = this.getSignupDomain();
    this.interframe = new Interframe(referrer, windowInstance, true);
    setTimeout(() => {
      this.interframe.subscribe(this.handleInterframeMessage);
    });
  }
  handleAppStarted() {
    this.interframe.postMessage({
      type: HANDSHAKE_MESSAGE_TYPE
    }, InterframeMessageTypes.JSON).then(response => {
      this.handshaked = response.type === ACKNOWLEDGE_MESSAGE_TYPE;
      if (this.config) {
        this.interframe.postMessage({
          type: INTEGRATION_MODAL_CONFIG_MESSAGE_TYPE,
          config: this.config
        }, InterframeMessageTypes.JSON);
      }
      this.interframe.postMessage({
        type: INTEGRATION_MODAL_STEP_MESSAGE_TYPE,
        step: 'CreateAccount'
      }, InterframeMessageTypes.JSON);
    }).catch(error => console.error(`SignupIntegrationModalEmbedder Error: ${error}`));
  }
}